module.exports = __webpack_public_path__ + "static/media/icon_137.2f30d272.svg";